export default __webpack_public_path__ + "static/media/logo_with_tashkeel.76001bd7.png";